const { object, string, number, boolean, array } = require('yup');

const RECOMMENDATION = 'recommendation';

module.exports = {
    REQUEST_CONTEXT: object({
        perseus_name: string().required(),
        componentName: string().required(),
    }),
    CONTEXT_ENRICHMENT_SCHEMA: object({
        impressionEnrichment: object({
            listings: object({
                carousel_position: number(),
                carousel_title: string(),
                page_ctx_id: string().required(),
                type: string(),
            }).required(),
        }).required(),
        context: object({
            queryParameters: object({
                context: string().default(RECOMMENDATION),
            }).required(),
            userId: number(),
            sourcePage: string().required(),
            viewportType: string(),
            sourceComponent: string().required(),
            currency: object({
                name: string(),
                rate: number(),
                symbol: string(),
            }).required(),
            pageCtxId: string().required(),
        }),
        isTouch: boolean().default(false),
    }),
    CAROUSEL_PROPERTIES_SCHEMA: object({
        gigs: array().required(),
        pro: boolean().default(false),
        title: string(),
        based_sc_title: object({
            pre_link: string(),
            post_link: string(),
            link_text: string(),
        }),
        link: object({
            text: string(),
            link: string(),
        }),
        category_id: number(),
        sub_category_id: number(),
    }),
    REQUEST_PROPS: object({
        pageCtxId: string().required(),
        isTouch: boolean().default(false),
        currency: object({
            rate: number(),
            template: string(),
            name: string(),
            forceRound: boolean().default(true),
            forceRoundFromAmount: number(),
            symbol: string(),
        }).required(),
        goPersonalizationUrl: string(),
        listingsPhoenixUrl: string(),
        cmsKimeraUrl: string(),
        federationGqlPegasusUrl: string(),
        podiumKimeraUrl: string(), // DEPRECATED in favour of `federationGqlPegasusUrl` | TODO: remove on the next major release
        requestsTimeouts: object({
            generalTimeout: number().default(35),
            federationGqlPegasusTO: number(),
            podiumKimeraTO: number(), // DEPRECATED in favour of `federationGqlPegasusTO` | TODO: remove on the next major release
        }),
        funnelProps: object({
            pageName: string().required(),
            gig: object({
                id: number(),
            }).nullable(),
            user: object({
                id: number(),
            }).nullable(),
            currentUser: object({
                id: number(),
            }).nullable(),
            currentPage: string().nullable(),
        }),
    }),
    SECTION_PROPS: object({
        sectionName: string().required(),
        isLoading: boolean().default(false),
        sliderBaseNum: number().default(5),
        personalizedContent: object().required(),
    }),
};
